import { render, staticRenderFns } from "./mktTextarea.vue?vue&type=template&id=65be0228&"
import script from "./mktTextarea.vue?vue&type=script&lang=js&"
export * from "./mktTextarea.vue?vue&type=script&lang=js&"
import style0 from "./mktTextarea.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports